import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { filter, map, startWith } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class LocalStorageService {
  private localStorageChange$: BehaviorSubject<string> = new BehaviorSubject('');

  getValue$<T>(key: string): Observable<T> {
    return this.onLocalStorageChange$().pipe(
      startWith(key),
      filter(event => event === key),
      map(key => this.getItem<T>(key)),
    );
  }

  onLocalStorageChange$(): Observable<string> {
    return this.localStorageChange$.asObservable();
  }

  setItem<T>(key: string, value: T): void {
    localStorage.setItem(key, JSON.stringify(value));
    this.localStorageChange$.next(key);
  }

  getItem$<T>(key: string): Observable<T> {
    return of(JSON.parse(localStorage.getItem(key)));
  }

  getItem<T>(key: string): T {
    return JSON.parse(localStorage.getItem(key));
  }
}
